<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">         
                    <v-form ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md12>
                                    <v-text-field :label="inputCodigoUnico" 
                                        :rules="rules.uniqueCode" v-model.trim="objectType.uniqueCode"/>
                                </v-flex>         

                                <v-flex xs12 md12>
                                    <v-text-field :label="inputDescricao" 
                                        :rules="rules.description" v-model.trim="objectType.description"/>
                                </v-flex> 

                                <v-flex class="d-flex justify-center">
                                    <v-btn color="red" @click="historyBack">
                                        <v-icon left>mdi-arrow-left</v-icon> 
                                        {{back}}
                                    </v-btn>     
                                    
                                    <v-btn color="green" @click="salvar">
                                        <v-icon left>mdi-check</v-icon> 
                                        {{save}}
                                    </v-btn>                 
                                </v-flex>                                
                            </v-layout>
                        </v-container>
                    </v-form>                                                    
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import Mixin from './mixin'

import ApiObjectType from '@/api/identityProvider/object-type'

export default {
    mixins: [ FormMixin, Mixin ], 
    data () {
        return { 
        }
    },
    created(){      
        this.formUniqueCode = "FORM.COAC.00001";
        this.privilegeUniqueCode = "ATUA";     
    },
    async mounted(){
        const loading = this.showLoading();
        await this.listar(this.$route.params.id);
        loading.close();
    },
    computed: {  
        text () {
            return this.$t('Views.ControleAcesso.TipoObjeto.Editar.form-text-edit')            
        }                                  
    },
    methods:{     
        async listar(id){
            const resultado = await ApiObjectType.listarPorId(id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.objectType = resultado.data;
            }
        },        
        async salvar(){
            if(!this.$refs.form.validate())
                return;

            const processing = this.showProcessing();
            const resultado = await ApiObjectType.alterar(this.objectType.id, this.objectType).catch(erro => this.showSnackbarError(erro.error));
            
            if(resultado.success)
                this.showMessage(
                    this.$t("Views.ControleAcesso.TipoObjeto.Editar.titulo-sucesso-alterado"), 
                    this.$t("Views.ControleAcesso.TipoObjeto.Editar.mensagem-sucesso-alterado"),
                    () => this.$router.push("/controle-acesso/tipo-objeto")
                );                

            else if(resultado.validationException)
                this.showError("Erro ao alterar o tipo de objeto", result.error);

            processing.close();  
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
